import React from "react";
import "./internship.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaReact } from "react-icons/fa6";
import { useTheme } from "../../context/ThemeContext";

const internshipData = [
  {
    title: "Emertex Academy",
    subtitle: "MERN Full StacK Developement",
    date: "01-08-2023 to 31-10-2024 (3 Months)",
    link: "https://drive.google.com/file/d/1jRoEJ-gUxuAFwN5c0uNompWi1-K015-I/view?usp=sharing",
  },
  {
    title: "BE Practical Tech Solution",
    subtitle: "Java Full Stack Development",
    date: "01-07-2024 to 31-12-2024 (6 Months)",
    link: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
];

const Internship = () => {
  const [theme] = useTheme();

  const openInNewWindow = (fileUrl) => {
    const width = 800;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    window.open(
      fileUrl,
      "_blank",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  return (
    <div className="work" id="internship">
      <div className="work-exp">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
          Internship
        </h2>
        <hr />
        <VerticalTimeline lineColor={theme === "light" ? "black" : "white"}>
          {internshipData.map(({ title, subtitle, date, link }, index) => (
            <VerticalTimelineElement
              key={index}
              className="vertical-timeline-element--work"
              contentStyle={{ background: "white", color: "black" }}
              contentArrowStyle={{ borderRight: "7px solid grey" }}
              date={<strong>{date}</strong>}
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<FaReact />}
            >
              <h3 className="vertical-timeline-element-title">{title}</h3>
              <h4 className="vertical-timeline-element-subtitle">{subtitle}</h4>
              <button
                className="ad-btn1 text-center"
                onClick={() => openInNewWindow(link)}
              >
                View
              </button>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
};

export default Internship;
